import {
  CREATE_TOURIST_SPOT_FAILURE,
  CREATE_TOURIST_SPOT_REQUEST,
  CREATE_TOURIST_SPOT_SUCCESS,
  DELETE_TOURIST_SPOT_FAILURE,
  DELETE_TOURIST_SPOT_REQUEST,
  DELETE_TOURIST_SPOT_SUCCESS,
  GET_TOURIST_SPOTS_FAILURE,
  GET_TOURIST_SPOTS_REQUEST,
  GET_TOURIST_SPOTS_SUCCESS,
  GET_TOURIST_SPOT_FAILURE,
  GET_TOURIST_SPOT_REQUEST,
  GET_TOURIST_SPOT_SUCCESS,
  DELETE_TOURIST_SPOT_PHOTO_FAILURE,
  DELETE_TOURIST_SPOT_PHOTO_REQUEST,
  DELETE_TOURIST_SPOT_PHOTO_SUCCESS,
  UPDATE_TOURIST_SPOT_FAILURE,
  UPDATE_TOURIST_SPOT_PHOTO_FAILURE,
  UPDATE_TOURIST_SPOT_PHOTO_SUCCESS,
  UPDATE_TOURIST_SPOT_PHOTO_REQUEST,
  UPDATE_TOURIST_SPOT_REQUEST,
  UPDATE_TOURIST_SPOT_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: false,
  loading: false,
  data: [],
  success: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOURIST_SPOTS_REQUEST:
      state = {
        ...state,
        data: [],
        loading: true,
        error: false,
      };
      break;

    case GET_TOURIST_SPOTS_SUCCESS:
      console.log("SUCCESS =)");

      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case GET_TOURIST_SPOTS_FAILURE:
      console.log("ERROR =(");

      state = {
        ...state,
        // data: [],
        loading: false,
        error: action.data,
      };
      break;

    case GET_TOURIST_SPOT_REQUEST:
      state = {
        ...state,
        // data: {},
        loading: true,
        error: false,
      };
      break;

    case GET_TOURIST_SPOT_SUCCESS:
      console.log("SUCCESS =)");

      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case GET_TOURIST_SPOT_FAILURE:
      console.log("ERROR =(");

      state = {
        ...state,
        // data: [],
        loading: false,
        error: action.data,
      };
      break;

    case CREATE_TOURIST_SPOT_REQUEST:
      console.log("REQUESTED...");

      state = {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
      break;

    case CREATE_TOURIST_SPOT_SUCCESS:
      console.log("SUCCESS =)");

      state = {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
      break;

    case CREATE_TOURIST_SPOT_FAILURE:
      console.log("ERROR =(");

      state = {
        ...state,
        loading: false,
        error: true,
        success: false,
      };
      break;

    case DELETE_TOURIST_SPOT_REQUEST:
      console.log("REQUEST =)");
      state = {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
      break;

    case DELETE_TOURIST_SPOT_SUCCESS:
      console.log("SUCCESS =)");
      state = {
        ...state,
        error: false,
        loading: false,
        success: true,
      };
      break;

    case DELETE_TOURIST_SPOT_FAILURE:
      console.log("ERROR =(");
      state = {
        ...state,
        // data: [],
        loading: false,
        error: action.data,
        success: false,
      };
      break;

    case DELETE_TOURIST_SPOT_PHOTO_REQUEST:
      console.log("REQUEST =)");
      state = {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
      break;

    case DELETE_TOURIST_SPOT_PHOTO_SUCCESS:
      console.log("SUCCESS =)");
      state = {
        ...state,
        error: false,
        loading: false,
        success: true,
      };
      break;

    case DELETE_TOURIST_SPOT_PHOTO_FAILURE:
      console.log("ERROR =(");
      state = {
        ...state,
        // data: [],
        loading: false,
        error: action.data,
        success: false,
      };
      break;

    case UPDATE_TOURIST_SPOT_REQUEST:
      state = {
        ...state,
        // data: {},
        loading: true,
        error: false,
      };
      break;

    case UPDATE_TOURIST_SPOT_SUCCESS:
      console.log("SUCCESS =)");

      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case UPDATE_TOURIST_SPOT_FAILURE:
      console.log("ERROR =(");

      state = {
        ...state,
        // data: [],
        loading: false,
        error: action.data,
      };
      break;

    case UPDATE_TOURIST_SPOT_PHOTO_REQUEST:
      state = {
        ...state,
        // data: {},
        loading: true,
        error: false,
      };
      break;

    case UPDATE_TOURIST_SPOT_PHOTO_SUCCESS:
      console.log("SUCCESS =)");

      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case UPDATE_TOURIST_SPOT_PHOTO_FAILURE:
      console.log("ERROR =(");

      state = {
        ...state,
        // data: [],
        loading: false,
        error: action.data,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default reducer;
